import {DatePickerWidget} from "../widget/DatePickerWidget";
import {toMs, toUtcDateStringShort} from "../../util/timeutils";
import {TaskDueIndicator} from "./TaskDueIndicator";

export const TaskDueWidget = ({due, onChange, props}) => {
    const dueDate = new Date(due);
    const now = new Date();
    let alert = 0;

    if (now > dueDate) {
        // past due
        alert = 1;
    } else if ((dueDate - now) <= toMs("1 day")) {
        alert = 1;
    } else if ((dueDate - now) <= toMs("2 days")) {
        alert = 2;
    }

    if (onChange) {
        let children = <div/>
        if (alert > 0) {
            children = <TaskDueIndicator alert={alert} />
        }
        return <DatePickerWidget date={due} onChange={onChange} placeholder={"due date"}>{children}</DatePickerWidget>
    } else {
        if (alert > 0) {
            return <div>{toUtcDateStringShort(new Date(due))} <TaskDueIndicator alert={alert} /></div>
        }
        return toUtcDateStringShort(new Date(due));
    }
}